export var EmailTag;
(function (EmailTag) {
    EmailTag["UNTAGGED"] = "UNTAGGED";
    EmailTag["MAIN"] = "MAIN";
    EmailTag["HOME"] = "HOME";
    EmailTag["WORK"] = "WORK";
})(EmailTag || (EmailTag = {}));
export var PhoneTag;
(function (PhoneTag) {
    PhoneTag["UNTAGGED"] = "UNTAGGED";
    PhoneTag["MAIN"] = "MAIN";
    PhoneTag["HOME"] = "HOME";
    PhoneTag["MOBILE"] = "MOBILE";
    PhoneTag["WORK"] = "WORK";
    PhoneTag["FAX"] = "FAX";
})(PhoneTag || (PhoneTag = {}));
export var AddressTag;
(function (AddressTag) {
    AddressTag["UNTAGGED"] = "UNTAGGED";
    AddressTag["HOME"] = "HOME";
    AddressTag["WORK"] = "WORK";
    AddressTag["BILLING"] = "BILLING";
    AddressTag["SHIPPING"] = "SHIPPING";
})(AddressTag || (AddressTag = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var ImageProvider;
(function (ImageProvider) {
    ImageProvider["UNKNOWN"] = "UNKNOWN";
    /** Image stored outside Wix */
    ImageProvider["EXTERNAL"] = "EXTERNAL";
    /** Stored in wix media platform, Must be uploaded by using `GeneratePictureUploadUrl` */
    ImageProvider["WIX_MEDIA"] = "WIX_MEDIA";
})(ImageProvider || (ImageProvider = {}));
export var ContactActivityType;
(function (ContactActivityType) {
    /** Visited the site. */
    ContactActivityType["GENERAL"] = "GENERAL";
    /** Became a new contact. */
    ContactActivityType["CONTACT_CREATED"] = "CONTACT_CREATED";
    /** Logged in. */
    ContactActivityType["MEMBER_LOGIN"] = "MEMBER_LOGIN";
    /** Requested a site membership. */
    ContactActivityType["MEMBER_REGISTER"] = "MEMBER_REGISTER";
    /** Was approved, blocked, or unblocked. */
    ContactActivityType["MEMBER_STATUS_CHANGED"] = "MEMBER_STATUS_CHANGED";
    /** Submitted a form. */
    ContactActivityType["FORM_SUBMITTED"] = "FORM_SUBMITTED";
    /** Started a chat. */
    ContactActivityType["INBOX_FORM_SUBMITTED"] = "INBOX_FORM_SUBMITTED";
    /** Paid a payment request. */
    ContactActivityType["INBOX_PAYMENT_REQUEST_PAID"] = "INBOX_PAYMENT_REQUEST_PAID";
    /** Received a message from the site. */
    ContactActivityType["INBOX_MESSAGE_TO_CUSTOMER"] = "INBOX_MESSAGE_TO_CUSTOMER";
    /** Sent a new message to the site. */
    ContactActivityType["INBOX_MESSAGE_FROM_CUSTOMER"] = "INBOX_MESSAGE_FROM_CUSTOMER";
    /** Subscribed to a site newsletter through a form. */
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED"] = "NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED";
    /** Unsubscribed from a site newsletter. */
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE"] = "NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE";
    /** Made a purchase. */
    ContactActivityType["ECOM_PURCHASE"] = "ECOM_PURCHASE";
    /** Abandoned a shopping cart. */
    ContactActivityType["ECOM_CART_ABANDON"] = "ECOM_CART_ABANDON";
    /** Checked out shopping cart and submitted buyer info (but didn’t complete the purchase yet). */
    ContactActivityType["ECOM_CHECKOUT_BUYER"] = "ECOM_CHECKOUT_BUYER";
    /** Booked an appointment. */
    ContactActivityType["BOOKINGS_APPOINTMENT"] = "BOOKINGS_APPOINTMENT";
    /** Made a Wix Hotels reservation. */
    ContactActivityType["HOTELS_RESERVATION"] = "HOTELS_RESERVATION";
    /** Paid for a Wix Hotels reservation. */
    ContactActivityType["HOTELS_PURCHASE"] = "HOTELS_PURCHASE";
    /** Confirmed a Wix Hotels reservation. */
    ContactActivityType["HOTELS_CONFIRMATION"] = "HOTELS_CONFIRMATION";
    /** Canceled a Wix Hotels reservation. */
    ContactActivityType["HOTELS_CANCEL"] = "HOTELS_CANCEL";
    /** Purchased a video. */
    ContactActivityType["VIDEO_PURCHASE"] = "VIDEO_PURCHASE";
    /** Rented a video. */
    ContactActivityType["VIDEO_RENT"] = "VIDEO_RENT";
    /** Made a purchase with a pay button. */
    ContactActivityType["CASHIER_BUTTON_PURCHASE"] = "CASHIER_BUTTON_PURCHASE";
    /** Became a new Wix Marketplace lead. */
    ContactActivityType["ARENA_NEW_LEAD"] = "ARENA_NEW_LEAD";
    /** RSVP'd to an event. */
    ContactActivityType["EVENTS_RSVP"] = "EVENTS_RSVP";
    /** Paid an invoice. */
    ContactActivityType["INVOICE_PAY"] = "INVOICE_PAY";
    /** An invoice is now overdue. */
    ContactActivityType["INVOICE_OVERDUE"] = "INVOICE_OVERDUE";
    /** Accepted a price quote. */
    ContactActivityType["PRICE_QUOTE_ACCEPT"] = "PRICE_QUOTE_ACCEPT";
    /** A price quote has expired. */
    ContactActivityType["PRICE_QUOTE_EXPIRE"] = "PRICE_QUOTE_EXPIRE";
    /** Ordered food with Wix Restaurants. */
    ContactActivityType["RESTAURANTS_ORDER"] = "RESTAURANTS_ORDER";
    /** Made a Wix Restaurants reservation. */
    ContactActivityType["RESTAURANTS_RESERVATION"] = "RESTAURANTS_RESERVATION";
    /** Opened an email from the site. */
    ContactActivityType["SHOUTOUT_OPEN"] = "SHOUTOUT_OPEN";
    /** Clicked a link in an email from the site. */
    ContactActivityType["SHOUTOUT_CLICK"] = "SHOUTOUT_CLICK";
    /** Merged with another contact. */
    ContactActivityType["CONTACT_MERGED"] = "CONTACT_MERGED";
    /** Subscribed to a site newsletter. */
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_SUBSCRIBE"] = "NEWSLETTER_SUBSCRIPTION_SUBSCRIBE";
    /** Subscription status to site newsletters is pending confirmation. */
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_PENDING"] = "NEWSLETTER_SUBSCRIPTION_PENDING";
    /** Subscription status to site newsletters is not set. */
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_NOT_SET"] = "NEWSLETTER_SUBSCRIPTION_NOT_SET";
    /** Subscribed to phone notifications. */
    ContactActivityType["PHONE_SUBSCRIPTION_SUBSCRIBE"] = "PHONE_SUBSCRIPTION_SUBSCRIBE";
    /** Subscription to phone notificatons is pending confirmation. */
    ContactActivityType["PHONE_SUBSCRIPTION_PENDING"] = "PHONE_SUBSCRIPTION_PENDING";
    /** Subscription to phone notificatons is not set. */
    ContactActivityType["PHONE_SUBSCRIPTION_NOT_SET"] = "PHONE_SUBSCRIPTION_NOT_SET";
    /** Subscribed to phone notifications. */
    ContactActivityType["PHONE_SUBSCRIPTION_UNSUBSCRIBE"] = "PHONE_SUBSCRIPTION_UNSUBSCRIBE";
})(ContactActivityType || (ContactActivityType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    /** Existing or new contact */
    IdentityType["CONTACT"] = "CONTACT";
    /** Member is logged in, matching logic skipped */
    IdentityType["MEMBER"] = "MEMBER";
    /** Matching contact is a member, Merge logic won't be applied */
    IdentityType["NOT_AUTHENTICATED_MEMBER"] = "NOT_AUTHENTICATED_MEMBER";
})(IdentityType || (IdentityType = {}));
export var SubmitOperation;
(function (SubmitOperation) {
    SubmitOperation["UNKNOWN"] = "UNKNOWN";
    SubmitOperation["CREATE"] = "CREATE";
    SubmitOperation["UPDATE"] = "UPDATE";
})(SubmitOperation || (SubmitOperation = {}));
export var ContactSourceType;
(function (ContactSourceType) {
    ContactSourceType["OTHER"] = "OTHER";
    ContactSourceType["ADMIN"] = "ADMIN";
    ContactSourceType["WIX_APP"] = "WIX_APP";
    ContactSourceType["IMPORT"] = "IMPORT";
    ContactSourceType["THIRD_PARTY"] = "THIRD_PARTY";
    ContactSourceType["WIX_BOOKINGS"] = "WIX_BOOKINGS";
    ContactSourceType["WIX_CHAT"] = "WIX_CHAT";
    ContactSourceType["WIX_EMAIL_MARKETING"] = "WIX_EMAIL_MARKETING";
    ContactSourceType["WIX_EVENTS"] = "WIX_EVENTS";
    ContactSourceType["WIX_FORMS"] = "WIX_FORMS";
    ContactSourceType["WIX_GROUPS"] = "WIX_GROUPS";
    ContactSourceType["WIX_HOTELS"] = "WIX_HOTELS";
    ContactSourceType["WIX_MARKET_PLACE"] = "WIX_MARKET_PLACE";
    ContactSourceType["WIX_MUSIC"] = "WIX_MUSIC";
    ContactSourceType["WIX_RESTAURANTS"] = "WIX_RESTAURANTS";
    ContactSourceType["WIX_SITE_MEMBERS"] = "WIX_SITE_MEMBERS";
    ContactSourceType["WIX_STORES"] = "WIX_STORES";
    ContactSourceType["WIX_CODE"] = "WIX_CODE";
    ContactSourceType["HOPP"] = "HOPP";
})(ContactSourceType || (ContactSourceType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map